import axios from 'axios';
import { convertStrDateToDMYFormat, convertStrDateToDMFormat } from '@beef/shop-common';
import { captureException } from '@sentry/react';

import { getHeaderRegionTitle } from 'store/common/header/selectors';
import { formatPhone } from 'utils/formatting';

import {
  OPEN_PARTNER_ORDER,
  SET_PRODUCT_NAME,
  SET_PRODUCT_PRICE,
  SET_ORDER_STEP,
  SET_COURIER_DATA,
  SET_COURIER_ACTIVE_DATE,
  SET_PICKUP_DATA,
  SET_DELIVERY_ACTIVE_OPTION,
  SET_POINTS_VIEW_STATE,
  SET_SEARCH_QUERY,
  SET_ACTIVE_POINT,
  SET_POINTS_COLLAPSED,
  SET_ACTIVE_PAYMENT_SLUG,
  SET_PRODUCT_ID,
  SET_COURIER_ADDRESS,
  SET_COURIER_DATE,
  SET_SUCCESS_MESSAGE,
  SET_DELIVERY_ERRORS,
  SET_PICKUP_SORT_BY,
  SET_PICKUP_REVERSE_STATE,
  SET_AGREEMENT_CONTENT,
  SET_COURIER_TIPS_ADDRESS,
} from './constants';
import {
  getCourierUrl,
  getPickupUrl,
  getDeliveryActiveSlug,
  getPartnerProductId,
  getPartnerProductName,
  getPickupActivePointData,
  getPickupActivePaymentSlug,
  getCourierDate,
  getCourierAddress,
  getCourierPaymentMethods,
  getPartnerSuccessMessage,
  getPickupActivePaymentName,
  getCourierComplete,
  getPickupComplete,
  getPrefix,
  getFinalPrice,
  getPickupSortReverseState,
  getCourierPriceValue,
} from './selectors';

export const clearCityHouses = () => ({
  type: SET_COURIER_TIPS_ADDRESS,
  list: [],
});

export const backFromAgreement = () => ({
  type: SET_ORDER_STEP,
  payload: 'contact',
});

export const setDeliveryActiveOption = (slug) => ({
  type: SET_DELIVERY_ACTIVE_OPTION,
  payload: slug,
});

export const setPointsViewState = (viewState) => ({
  type: SET_POINTS_VIEW_STATE,
  payload: viewState,
});

export const setSearchQuery = (value) => ({
  type: SET_SEARCH_QUERY,
  payload: value,
});

export const uncollapsePoints = () => ({
  type: SET_POINTS_COLLAPSED,
  payload: false,
});

export const setActivePaymentSlug = (slug) => ({
  type: SET_ACTIVE_PAYMENT_SLUG,
  payload: slug,
});

export const setCourierAddress = (value) => ({
  type: SET_COURIER_ADDRESS,
  payload: value,
});

export const setCourierDate = (value) => ({
  type: SET_COURIER_DATE,
  payload: value,
});

export const getCityHouses = (value) => (dispatch, getState) => {
  const state = getState();
  const cityName = getHeaderRegionTitle(state);

  axios({
    method: 'post',
    url: '/shop/basket/GetCityHouses',
    responseType: 'json',
    data: {
      json: JSON.stringify({
        cityTerm: cityName,
        term: value,
        count: '5',
      }),
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => {
      const responseData = response.data || {};
      const dataView = JSON.parse(responseData.View || {});
      if (responseData.IsSucceeded && dataView) {
        dispatch({
          type: SET_COURIER_TIPS_ADDRESS,
          payload: dataView,
        });
      } else {
        // обработка ошибки витрины
      }
    })
    .catch(captureException);
};

export const showAgreement = (slug) => (dispatch) => {
  let url = '';
  let heading = '';
  if (slug === 'props') {
    heading = '<h2>Условия продажи</h2>';
    url = '/shop/sitetext/?key=SHOP_CONTENT_PICKUP_BUY_PROPS';
  }
  if (slug === 'agreement') {
    url = '/shop/sitetext/?key=SHOP_CONTENT_PICKUP_BUY_AGREEMENT';
    heading = '<h2>Согласие на обработку персональных данных</h2>';
  }
  axios({
    method: 'get',
    url,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => {
      const content = `${heading}${response.data}`;
      dispatch({
        type: SET_AGREEMENT_CONTENT,
        payload: content,
      });

      dispatch({
        type: SET_ORDER_STEP,
        payload: 'agreement',
      });
    })
    .catch(captureException);
};

export const onSortPickupPoints = (sortBy) => (dispatch, getState) => {
  const state = getState();
  const reverseState = getPickupSortReverseState(state);

  dispatch({
    type: SET_PICKUP_SORT_BY,
    payload: sortBy,
  });

  dispatch({
    type: SET_PICKUP_REVERSE_STATE,
    payload: !reverseState,
  });
};

export const fetchDeliveryData = (data, url, onSuccess, onError) => {
  axios({
    method: 'post',
    url,
    data,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onError(error);
    });
};

const onSuccessPickup = (getState, dispatch) => (response) => {
  const state = getState();
  const deliveryActiveSlug = getDeliveryActiveSlug(state);
  const data = response.data || {};
  if (data.isSucceeded) {
    const { view } = data;

    if ((view || []).length) {
      const pointsRaw = view || [];
      const points = pointsRaw.map((point) => {
        const deliveryDays = point.deliveryDays || [];
        const deliveryDay = deliveryDays[0] || null;
        return {
          address: point.address,
          deliveryDays,
          minDate: deliveryDay,
          latitude: point.lat,
          longitude: point.lon,
          name: point.name,
          opening: point.opening,
          partner: point.partner,
          phone: point.phone,
          pointCode: point.id,
          ptype: 'partner',
          priceTitle: point.price ? `Стоимость  ${point.price} ₽` : 'Бесплатно',
          availableDate: deliveryDay ? `${convertStrDateToDMFormat(deliveryDay)} и позднее` : '',
          paymentMethods: point.paymentMethods,
        };
      });

      const pickupData = {
        slug: 'pickup',
        title: 'Самовывоз',
        points,
      };

      dispatch({
        type: SET_PICKUP_DATA,
        payload: points.length ? pickupData : null,
      });

      if (!deliveryActiveSlug) {
        dispatch({
          type: SET_DELIVERY_ACTIVE_OPTION,
          payload: 'pickup',
        });
      }
    }
  }
};

const onSuccessCourier = (getState, dispatch) => (response) => {
  const data = response.data || {};
  if (data.isSucceeded) {
    const { view } = data;

    if (view) {
      const dates = (view.availableDates || []).map((date) => {
        const interval = view.intervals[date] || {};
        return {
          id: interval.id,
          date,
          price: interval.price,
        };
      });

      const paymentMethods = (view.paymentMethods || []).map((method) => ({
        name: method.name,
        slug: method.slug,
      }));

      const courierData = {
        slug: 'courier',
        title: 'Доставка',
        dates,
        startDate: view.startDate,
        paymentMethods,
      };

      dispatch({
        type: SET_COURIER_DATA,
        payload: courierData,
      });

      dispatch({
        type: SET_COURIER_ACTIVE_DATE,
        payload: view.StartDate,
      });

      dispatch({
        type: SET_DELIVERY_ACTIVE_OPTION,
        payload: 'courier',
      });
    }
  }
};

const onErrorDelivery = (error) => {
  captureException(error);
};

export const openPartnerPopup =
  (itemId, partnerSlug, productName, productPrice) => (dispatch, getState) => {
    const state = getState();
    const urlCourier = getCourierUrl(state);
    const urlPickup = getPickupUrl(state);
    const data = { itemId, partnerSlug };

    // ---- Установить айди парнера
    dispatch({
      type: SET_PRODUCT_ID,
      payload: itemId,
    });

    // ---- Установить название товара
    dispatch({
      type: SET_PRODUCT_NAME,
      payload: productName,
    });

    // ---- Установить цену товара
    dispatch({
      type: SET_PRODUCT_PRICE,
      payload: productPrice,
    });

    // ---- Показать попап
    dispatch({
      type: OPEN_PARTNER_ORDER,
      payload: true,
    });

    // ---- Вызвать метод по курьерской доставке
    fetchDeliveryData(data, urlCourier, onSuccessCourier(getState, dispatch), onErrorDelivery);

    // ---- Вызвать метод по точкам самовывоза
    fetchDeliveryData(data, urlPickup, onSuccessPickup(getState, dispatch), onErrorDelivery);
  };

export const closePartnerPopup = () => (dispatch) => {
  dispatch({
    type: OPEN_PARTNER_ORDER,
    payload: false,
  });

  dispatch({
    type: SET_ORDER_STEP,
    payload: 'start',
  });

  dispatch({
    type: SET_PICKUP_DATA,
    payload: null,
  });

  dispatch({
    type: SET_COURIER_DATA,
    payload: null,
  });
};

export const switchToContact = () => (dispatch, getState) => {
  const state = getState();
  const deliverySlug = getDeliveryActiveSlug(state);
  const isCourierComplete = getCourierComplete(state);
  const isPickupComplete = getPickupComplete(state);

  const deliveryErrors = {};

  if (!isCourierComplete && deliverySlug === 'courier') {
    deliveryErrors.courier = 'Введите адрес';
  }

  if (!isPickupComplete && deliverySlug === 'pickup') {
    deliveryErrors.pickup = 'Выберите точку продаж';
  }

  dispatch({
    type: SET_DELIVERY_ERRORS,
    payload: deliveryErrors,
  });

  if (!deliveryErrors.courier && !deliveryErrors.pickup) {
    dispatch({
      type: SET_ORDER_STEP,
      payload: 'contact',
    });
  }
};

export const setActivePoint = (isOpen, point) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_POINT,
    payload: point,
  });

  dispatch({
    type: SET_POINTS_COLLAPSED,
    payload: true,
  });

  dispatch({
    type: SET_ACTIVE_PAYMENT_SLUG,
    payload: ((point || {}).paymentMethods || [])[0].slug || null,
  });
};

export const orderBuy = (formData) => (dispatch, getState) => {
  const state = getState();
  const orderBuyUrl = '/shop/partner_create_order/';
  const productId = getPartnerProductId(state);
  const productName = getPartnerProductName(state);
  const deliverySlug = getDeliveryActiveSlug(state);
  const pointData = getPickupActivePointData(state);
  const city = getHeaderRegionTitle(state);
  const courierDate = getCourierDate(state);
  const courierAddress = getCourierAddress(state);
  const pickupPaymentSlug = getPickupActivePaymentSlug(state);
  const pickupPaymentName = getPickupActivePaymentName(state);
  const courierPaymentMethods = getCourierPaymentMethods(state);
  const successMessageTemplate = getPartnerSuccessMessage(state);
  const prefix = getPrefix(state);
  const finalPrice = getFinalPrice(state);
  const courierPrice = getCourierPriceValue(state);

  const getDeliveryType = () => {
    if (deliverySlug === 'courier') return 'delivery';
    if (deliverySlug === 'pickup') return 'pickup';
    return null;
  };

  const getPaymentSlug = () => {
    if (deliverySlug === 'courier') return (courierPaymentMethods[0] || {}).slug || null;
    if (deliverySlug === 'pickup') return pickupPaymentSlug;
    return null;
  };

  const getPaymentName = () => {
    if (deliverySlug === 'courier') return (courierPaymentMethods[0] || {}).name || null;
    if (deliverySlug === 'pickup') return pickupPaymentName;
    return null;
  };

  const activeDate = deliverySlug === 'courier' ? courierDate : pointData.minDate;
  const pointCode = deliverySlug === 'courier' ? null : pointData.pointCode;
  const address = deliverySlug === 'courier' ? courierAddress : pointData.address;
  const deliveryPrice = deliverySlug === 'courier' ? courierPrice : 0;

  const { name, surname, phone, email } = formData;

  const request = {
    client: {
      firstName: name,
      lastName: surname,
      email,
      phone,
    },
    cartItems: [
      {
        article: productId,
        quantity: 1,
      },
    ],
    partnerDelivery: {
      address: {
        street: address,
        city,
      },
      type: getDeliveryType(),
      date: activeDate,
      pointCode,
      price: deliveryPrice,
    },
    payment: {
      slug: getPaymentSlug(),
    },
  };

  axios({
    method: 'post',
    url: orderBuyUrl,
    data: {
      orderjSon: JSON.stringify(request),
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    responseType: 'json',
    transformRequest: [
      (data) => {
        const serializedData = [];
        Object.keys(data).forEach((k) => {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
          }
        });
        return serializedData.join('&');
      },
    ],
  }).then((response) => {
    const data = response.data || {};
    if (data.isSucceeded) {
      const { view } = data;
      const orderNumber = view.orderNumber || '';

      const replacer = (value) => {
        const replaceValue = {
          '{name}': productName,
          '{prefix}': prefix,
          '{date}': convertStrDateToDMYFormat(activeDate),
          '{address}': address,
          '{payment}': getPaymentName(),
          '{phone}': formatPhone(phone),
          '{ordernumber}': orderNumber,
          '{price}': finalPrice,
        }[value];
        return replaceValue || value;
      };

      const successMessage = successMessageTemplate.replace(
        /{price}|{name}|{prefix}|{date}|{address}|{payment}|{phone}|{ordernumber}/g,
        replacer,
      );

      dispatch({
        type: SET_SUCCESS_MESSAGE,
        payload: successMessage,
      });

      dispatch({
        type: SET_ORDER_STEP,
        payload: 'success',
      });
    }
  });
};
